var map = {
	"./404.svg": 8603,
	"./bug.svg": 2141,
	"./chart.svg": 1447,
	"./clipboard.svg": 297,
	"./component.svg": 26,
	"./dashboard.svg": 855,
	"./documentation.svg": 4933,
	"./drag.svg": 4363,
	"./edit.svg": 2797,
	"./education.svg": 129,
	"./email.svg": 4427,
	"./example.svg": 5009,
	"./excel.svg": 5594,
	"./exit-fullscreen.svg": 9469,
	"./eye-open.svg": 9901,
	"./eye.svg": 5276,
	"./form.svg": 5723,
	"./fullscreen.svg": 3854,
	"./guide.svg": 8659,
	"./icon.svg": 1726,
	"./international.svg": 2579,
	"./language.svg": 6687,
	"./link.svg": 2341,
	"./list.svg": 4633,
	"./lock.svg": 7660,
	"./message.svg": 8998,
	"./money.svg": 2731,
	"./nested.svg": 88,
	"./password.svg": 7294,
	"./pdf.svg": 2913,
	"./people.svg": 8920,
	"./peoples.svg": 6987,
	"./qq.svg": 415,
	"./search.svg": 7673,
	"./shopping.svg": 1921,
	"./size.svg": 3022,
	"./skill.svg": 3296,
	"./star.svg": 1693,
	"./tab.svg": 726,
	"./table.svg": 4431,
	"./theme.svg": 9372,
	"./tree-table.svg": 2230,
	"./tree.svg": 4397,
	"./user.svg": 9939,
	"./wechat.svg": 2863,
	"./zip.svg": 3326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3037;